﻿import { Grid, Paper } from "@mui/material";
import { FC } from "react";
import { SCUITabs } from "../../../../atomic/atoms";
import { useHistory } from "react-router-dom";
import { CMP } from "./customerMenuPaper.classes";

interface IProps {
  tabList?: any;
  tIndex?: any;
  setIndex?: any;
  setTabIndex?: any;
}
export const CustomerMenuPaper: FC<IProps> = ({
  tabList,
  tIndex,
  setIndex,
  setTabIndex,
}) => {
  const history = useHistory();

  const _onChangeTabs = (event: any, activeTabIndex: any): void => {
    setIndex(activeTabIndex);
    setTabIndex(activeTabIndex);
    history.push(tabList.find((item: any) => item.id === activeTabIndex).link);
  };

  return (
    <Paper className={CMP.page}>
      <Grid className={CMP.tabsGrid}>
        <SCUITabs
          tabList={tabList}
          onChange={_onChangeTabs}
          activeTabIndex={tIndex}
          orientation={"vertical"}
          indicatorColor="red"
        ></SCUITabs>
      </Grid>
    </Paper>
  );
};

